import { z } from 'zod'

import { MetricPeriod, MetricType } from '../constants/metric'
import { dbEntitySchema } from './system'

export const reservationMeasuresSchema = z.object({
  currencyCode: z.string().optional(),
  total: z.number().optional(),
  expected: z.number().optional(),
  spent: z.number().optional(),
  expectedSpent: z.number().optional(),
  checkedIn: z.number().optional(),
  closed: z.number().optional(),
  cancelled: z.number().optional(),
  noShow: z.number().optional(),
  pending: z.number().optional(),
  denied: z.number().optional(),
  confirmed: z.number().optional(),
  guestsCheckedIn: z.number().optional(),
  guestsExpected: z.number().optional(),
  guestsCheckedInMale: z.number().optional(),
  guestsCheckedInFemale: z.number().optional(),
  guestsCheckedInUnisex: z.number().optional(),
  guestsExpectedMale: z.number().optional(),
  guestsExpectedFemale: z.number().optional(),
  guestsExpectedUnisex: z.number().optional(),
  // prepaid breakdown
  prepaidSubtotal: z.number().optional(),
  prepaidTax: z.number().optional(),
  prepaidTip: z.number().optional(),
  prepaidVenueFees: z.number().optional(),
  prepaidProcessingFees: z.number().optional(),
  userPaidProcessingFeeTotal: z.number().optional(),
  venueAbsorbedProcessingFeeTotal: z.number().optional(),
  prepaidTotal: z.number().optional(),
  prepaidVenuePayout: z.number().optional(),
  avgSpent: z.number().optional(),
  avgPrepaidTotal: z.number().optional(),
})

export const admissionMeasuresSchema = z.object({
  currencyCode: z.string().optional(),
  total: z.number().optional(),
  expected: z.number().optional(),
  checkedIn: z.number().optional(),
  closed: z.number().optional(),
  cancelled: z.number().optional(),
  noShow: z.number().optional(),
  pending: z.number().optional(),
  denied: z.number().optional(),
  confirmed: z.number().optional(),
  guestsCheckedIn: z.number().optional(),
  guestsExpected: z.number().optional(),
  spent: z.number().optional(),
  expectedSpent: z.number().optional(),
  guestsCheckedInMale: z.number().optional(),
  guestsCheckedInFemale: z.number().optional(),
  guestsCheckedInUnisex: z.number().optional(),
  guestsExpectedMale: z.number().optional(),
  guestsExpectedFemale: z.number().optional(),
  guestsExpectedUnisex: z.number().optional(),
  // prepaid breakdown
  prepaidSubtotal: z.number().optional(),
  prepaidTax: z.number().optional(),
  prepaidTip: z.number().optional(),
  prepaidVenueFees: z.number().optional(),
  prepaidProcessingFees: z.number().optional(),
  userPaidProcessingFeeTotal: z.number().optional(),
  venueAbsorbedProcessingFeeTotal: z.number().optional(),
  prepaidTotal: z.number().optional(),
  prepaidVenuePayout: z.number().optional(),
  avgSpent: z.number().optional(),
})

export const ticketMeasuresSchema = z.object({
  currencyCode: z.string().optional(),
  total: z.number().optional(),
  checkedIn: z.number().optional(),
  closed: z.number().optional(),
  guestsCheckedIn: z.number().optional(),
  guestsExpected: z.number().optional(),
  spent: z.number().optional(),
  expectedSpent: z.number().optional(),
  cancelled: z.number().optional(),
  noShow: z.number().optional(),
  guestsCheckedInMale: z.number().optional(),
  guestsCheckedInFemale: z.number().optional(),
  guestsCheckedInUnisex: z.number().optional(),
  guestsExpectedMale: z.number().optional(),
  guestsExpectedFemale: z.number().optional(),
  guestsExpectedUnisex: z.number().optional(),
  // prepaid breakdown
  prepaidSubtotal: z.number().optional(),
  prepaidTax: z.number().optional(),
  prepaidTip: z.number().optional(),
  prepaidVenueFees: z.number().optional(),
  prepaidProcessingFees: z.number().optional(),
  userPaidProcessingFeeTotal: z.number().optional(),
  venueAbsorbedProcessingFeeTotal: z.number().optional(),
  prepaidTotal: z.number().optional(),
  prepaidVenuePayout: z.number().optional(),
  avgSpent: z.number().optional(),
})

export const guestlistMeasuresSchema = z.object({
  currencyCode: z.string().optional(),
  total: z.number().optional(),
  checkedIn: z.number().optional(),
  closed: z.number().optional(),
  guestsCheckedIn: z.number().optional(),
  guestsExpected: z.number().optional(),
  spent: z.number().optional(),
  expectedSpent: z.number().optional(),
  cancelled: z.number().optional(),
  noShow: z.number().optional(),
  guestsCheckedInMale: z.number().optional(),
  guestsCheckedInFemale: z.number().optional(),
  guestsCheckedInUnisex: z.number().optional(),
  guestsExpectedMale: z.number().optional(),
  guestsExpectedFemale: z.number().optional(),
  guestsExpectedUnisex: z.number().optional(),
  confirmedGuests: z.number().optional(),
  closedGuests: z.number().optional(),
  cancelledGuests: z.number().optional(),
  // prepaid breakdown
  prepaidSubtotal: z.number().optional(),
  prepaidTax: z.number().optional(),
  prepaidTip: z.number().optional(),
  prepaidVenueFees: z.number().optional(),
  prepaidProcessingFees: z.number().optional(),
  prepaidTotal: z.number().optional(),
  prepaidVenuePayout: z.number().optional(),
  avgSpent: z.number().optional(),
})

export const tallyMeasuresSchema = z.object({
  currencyCode: z.string().optional(),
  total: z.number().optional(),
  checkedIn: z.number().optional(),
  closed: z.number().optional(),
  guestsCheckedIn: z.number().optional(),
  guestsExpected: z.number().optional(),
  spent: z.number().optional(),
  expectedSpent: z.number().optional(),
  cancelled: z.number().optional(),
  noShow: z.number().optional(),
  guestsCheckedInMale: z.number().optional(),
  guestsCheckedInFemale: z.number().optional(),
  guestsCheckedInUnisex: z.number().optional(),
  guestsExpectedMale: z.number().optional(),
  guestsExpectedFemale: z.number().optional(),
  guestsExpectedUnisex: z.number().optional(),
  // prepaid breakdown
  prepaidSubtotal: z.number().optional(),
  prepaidTax: z.number().optional(),
  prepaidTip: z.number().optional(),
  prepaidVenueFees: z.number().optional(),
  prepaidProcessingFees: z.number().optional(),
  prepaidTotal: z.number().optional(),
  prepaidVenuePayout: z.number().optional(),
})

export const leadsMeasuresSchema = z.object({
  total: z.number().optional(),
  pending: z.number().optional(),
  confirmed: z.number().optional(),
  checkedIn: z.number().optional(),
  closed: z.number().optional(),
  denied: z.number().optional(),
  converted: z.number().optional(),
})

export const inventoryMeasuresSchema = z.object({
  inventoryId: z.string().optional(),
  inventoryName: z.string().optional(),
  inventoryType: z.string().optional(),
  spent: z.number().optional(),
  total: z.number().optional(),
  totalPaymentLinks: z.number().optional(),
  totalReservations: z.number().optional(),
  totalAdmissions: z.number().optional(),
  totalTickets: z.number().optional(),
  totalGuestlists: z.number().optional(),
  totalTallies: z.number().optional(),
})

export const inventoryPriceMeasuresSchema = z.object({
  eventId: z.string().optional(),
  inventoryId: z.string().optional(),
  inventoryName: z.string().optional(),
  price: z.number().optional(),
  quantitySold: z.number().optional(),
  spent: z.number().optional(),
})

export const purchaseDateMeasuresSchema = z.object({
  eventId: z.string().optional(),
  date: z.string().optional(),
  quantitySold: z.number().optional(),
  spent: z.number().optional(),
})

/**
 * Aggregated admission-group analytics fields for a metric window.
 *
 * Notes:
 * - Field names are legacy-compatible reporting keys and are intentionally preserved.
 * - Values are pre-aggregated totals for the selected period (daily/monthly rollups).
 * - Some names are not ideal; see naming guidance below for suggested aliases.
 */
export const admissionGroupMeasuresSchemaBase = z.object({
  aggregate: z.object({
    currencyCode: z.string().optional(),
    // Revenue-like totals (legacy naming kept for compatibility)
    spent: z.number().optional(),
    expectedSpent: z.number().optional(),

    // Prepaid component totals (aligned with pricing breakdown terminology)
    prepaidSubtotal: z.number().optional(),
    prepaidTax: z.number().optional(),
    prepaidTip: z.number().optional(),
    prepaidVenueFees: z.number().optional(),
    prepaidProcessingFees: z.number().optional(),
    prepaidTotal: z.number().optional(),
    prepaidVenuePayout: z.number().optional(),

    // Processing-fee split totals
    processingFeeTotal: z.number().optional(),
    userPaidProcessingFeeTotal: z.number().optional(),
    venueAbsorbedProcessingFeeTotal: z.number().optional(),
    ticketProcessingFeeTotal: z.number().optional(),
    tableProcessingFeeTotal: z.number().optional(),
    connectProcessingFeeTotal: z.number().optional(),
    nonConnectProcessingFeeTotal: z.number().optional(),
    paymentProviderProcessingFeeTotal: z.number().optional(),
    paymentProviderApplicationFeeTotal: z.number().optional(),

    // Venue-owned fee totals (non-processing fees)
    venueFeeTotal: z.number().optional(),

    // Volume counters
    admissionGroups: z.number().optional(),
    leads: z.number().optional(),
  }),
  reservations: reservationMeasuresSchema,
  admissions: admissionMeasuresSchema,
  tickets: ticketMeasuresSchema,
  guestlists: guestlistMeasuresSchema,
  tally: tallyMeasuresSchema,
  leads: leadsMeasuresSchema,
  paymentLinks: z
    .object({
      total: z.number().optional(),
      reservations: reservationMeasuresSchema
        .partial()
        .extend({ avgProportion: z.number().optional() }),
      tickets: ticketMeasuresSchema.partial(),
      guestlists: guestlistMeasuresSchema.partial(),
      tally: tallyMeasuresSchema.partial(),
    })
    .optional(),
})

/**
 * Naming alternatives (documentation only; no schema key changes):
 * - spent -> grossSales
 * - expectedSpent -> projectedSales
 * - prepaidSubtotal -> preTaxSales
 * - prepaidProcessingFees -> paymentProcessingFees
 * - prepaidVenuePayout -> merchantNetPayout
 * - userPaidProcessingFeeTotal -> customerPaidProcessingFees
 * - venueAbsorbedProcessingFeeTotal -> merchantAbsorbedProcessingFees
 * - venueFeeTotal -> serviceFees (or merchantServiceFees)
 *
 * These suggestions mirror common POS terminology in restaurant/bar/retail systems.
 */

export const attributionMeasuresSchema =
  admissionGroupMeasuresSchemaBase.extend({
    attributionId: z.string().optional(),
    attributionName: z.string().optional(),
    attributionType: z.string().nullish(),
    totalPaymentLinks: z.number().optional(),
  })

/** Per day-of-week rollup; occurrenceCount is distinct diary nights in the bucket
 * (sums on merge). dayOfWeek is an identity (0–6) and must not be summed. */
export const dayOfWeekMeasuresSchema = admissionGroupMeasuresSchemaBase.extend({
  dayOfWeek: z.number().min(0).max(6),
  occurrenceCount: z.number().optional(),
})

/** Per recurring series (`event.recurring.identifier`); one-offs omitted.
 * occurrenceCount is distinct diary nights for the series (sums on merge). */
export const recurringIdentifierMeasuresSchema =
  admissionGroupMeasuresSchemaBase.extend({
    recurringIdentifier: z.string(),
    recurringEventName: z.string().optional(),
    occurrenceCount: z.number().optional(),
  })

export const admissionGroupMeasuresSchema =
  admissionGroupMeasuresSchemaBase.extend({
    byAttributionId: z.record(z.string(), attributionMeasuresSchema).optional(),
    byInventory: z.record(z.string(), inventoryMeasuresSchema).optional(),
    byInventoryPrice: z
      .record(z.string(), inventoryPriceMeasuresSchema)
      .optional(),
    byPurchaseDate: z.record(z.string(), purchaseDateMeasuresSchema).optional(),
    byDayOfWeek: z.record(z.string(), dayOfWeekMeasuresSchema).optional(),
    byRecurringIdentifier: z
      .record(z.string(), recurringIdentifierMeasuresSchema)
      .optional(),
  })

export const customerMeasuresSchema = z.object({
  totalNewCustomers: z.number().optional(),
  totalCustomers: z.number().optional(),
  totalSpend: z.number().optional(),
  totalVisits: z.number().optional(),
  totalTableVisits: z.number().optional(),
  totalTicketVisits: z.number().optional(),
  totalGuestlistVisits: z.number().optional(),
})

export const trackingEventsEntityMeasuresSchema = z.object({
  pageViews: z.number().optional(),
  uniquePageViews: z.number().optional(),
  itemViews: z.number().optional(),
  checkoutsStarted: z.number().optional(),
  purchases: z.number().optional(),
})

export const trackingEventsMeasuresSchema = z.object({
  totals: trackingEventsEntityMeasuresSchema,
  rates: z.object({
    viewToCheckoutRate: z.number().optional(),
    checkoutToPurchaseRate: z.number().optional(),
    viewToPurchaseRate: z.number().optional(),
  }),
  byVenue: z.record(z.string(), trackingEventsEntityMeasuresSchema).optional(),
  byEvent: z.record(z.string(), trackingEventsEntityMeasuresSchema).optional(),
})

export const organizationMeasuresSchema = z.object({
  total: z.number().optional(),
  subscriptionActive: z.number().optional(),
})

export const platformVenueMeasuresSchema = z.object({
  total: z.number().optional(),
  subscriptionActive: z.number().optional(),
})

function isAdmissionGroupMeasuresShape(val: unknown): boolean {
  if (val == null || typeof val !== 'object') return false

  return (
    'aggregate' in val ||
    'reservations' in val ||
    'admissions' in val ||
    'paymentLinks' in val ||
    'tickets' in val ||
    'guestlists' in val ||
    'tally' in val ||
    'leads' in val ||
    'byAttributionId' in val ||
    'byInventory' in val ||
    'byInventoryPrice' in val ||
    'byPurchaseDate' in val ||
    'byDayOfWeek' in val ||
    'byRecurringIdentifier' in val
  )
}

// Order matters: customer/org/venue schemas are all-optional objects, so without
// strict() and ordering, Zod matches customer first and strips platform keys.
// Refine org/venue/customer branches so admission-group-shaped payloads never
// fall through and produce misleading "unrecognized key" errors.
const metricMeasuresSchema = z.union([
  admissionGroupMeasuresSchema,
  trackingEventsMeasuresSchema,
  organizationMeasuresSchema
    .strict()
    .refine((val) => !isAdmissionGroupMeasuresShape(val)),
  platformVenueMeasuresSchema
    .strict()
    .refine((val) => !isAdmissionGroupMeasuresShape(val)),
  customerMeasuresSchema
    .strict()
    .refine((val) => !isAdmissionGroupMeasuresShape(val)),
])

const metricDateFieldSchema = z.coerce.date()

export const metricSchema = dbEntitySchema.extend({
  created: metricDateFieldSchema,
  modified: metricDateFieldSchema,
  type: z.nativeEnum(MetricType),
  period: z.nativeEnum(MetricPeriod),
  date: metricDateFieldSchema,
  measures: metricMeasuresSchema.optional().nullable(),
  venue: z.string().optional(),
  organization: z.string().optional(),
})

export const metricBatchSchema = z.object({
  venue: z.string(),
  date: z.date(),
})

export const metricsListArgsSchema = z.object({
  organizationId: z.string().optional(),
  venueId: z.string().or(z.array(z.string())).optional(),
  type: z.nativeEnum(MetricType).or(z.array(z.nativeEnum(MetricType))),
  period: z.nativeEnum(MetricPeriod),
  dateStart: z.coerce.date(),
  dateEnd: z.coerce.date(),
  createdStart: z.coerce.date().optional(),
  createdEnd: z.coerce.date().optional(),
})

//response schemas
export const aggregateByAttributionItemSchema = z.object({
  attributionId: z.string(),
  attributionName: z.string(),
  attributionType: z.string().optional(),
  measures: admissionGroupMeasuresSchema,
})

export const aggregateByInventoryItemSchema = z.object({
  inventory: z.string(),
  inventoryType: z.string(),
  inventoryName: z.string(),
  measures: inventoryMeasuresSchema,
})

export const aggregateByInventoryPriceItemSchema = z.object({
  eventId: z.string().optional(),
  inventory: z.string(),
  inventoryName: z.string(),
  price: z.number(),
  measures: inventoryPriceMeasuresSchema,
})

export const aggregateByPurchaseDateItemSchema = z.object({
  eventId: z.string().optional(),
  date: z.string(),
  measures: purchaseDateMeasuresSchema,
})

export const aggregateByDayOfWeekItemSchema = z.object({
  dayOfWeek: z.number().min(0).max(6),
  measures: dayOfWeekMeasuresSchema,
})

export const aggregateByRecurringIdentifierItemSchema = z.object({
  recurringIdentifier: z.string(),
  recurringEventName: z.string().optional(),
  measures: recurringIdentifierMeasuresSchema,
})

export const metricsListAggregateSchema = z.object({
  metrics: z.array(metricSchema),
  aggregate: admissionGroupMeasuresSchema.partial().optional(),
  aggregateByAttribution: z.array(aggregateByAttributionItemSchema).optional(),
  aggregateByInventory: z.array(aggregateByInventoryItemSchema).optional(),
  aggregateByInventoryPrice: z
    .array(aggregateByInventoryPriceItemSchema)
    .optional(),
  aggregateByPurchaseDate: z
    .array(aggregateByPurchaseDateItemSchema)
    .optional(),
  aggregateByDayOfWeek: z.array(aggregateByDayOfWeekItemSchema).optional(),
  aggregateByRecurringIdentifier: z
    .array(aggregateByRecurringIdentifierItemSchema)
    .optional(),
})

export const metricsListResponseSchema = z.object({
  data: metricsListAggregateSchema,
})

export const upcomingPipelineDaysSchema = z.preprocess(
  (value) => (typeof value === 'string' ? Number(value) : value),
  z.union([z.literal(7), z.literal(14), z.literal(30)])
)

export const upcomingPipelineArgsSchema = z.object({
  venueId: z.string().or(z.array(z.string())),
  days: upcomingPipelineDaysSchema.default(14),
})

export const upcomingPipelineDaySchema = z.object({
  date: z.string(),
  dayOfWeek: z.number().min(0).max(6),
  bookings: z.number(),
  expectedSpent: z.number(),
  prepaidSubtotal: z.number(),
  guestsExpected: z.number(),
})

export const upcomingPipelineAggregateSchema = z.object({
  days: z.array(upcomingPipelineDaySchema),
  windowDays: upcomingPipelineDaysSchema,
})

export const upcomingPipelineResponseSchema = z.object({
  data: upcomingPipelineAggregateSchema,
})
